import React, {Component} from 'react';
import styles from "./myimg.module.css";

import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import defaultImg from '../../img/bee.png';

class Prompt extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [

        ]);
        this.state = {
            imageUrl: props.src,

        }
    }

    componentDidMount(){

    }

    handleImageLoaded(){
        // this.setState({
        //     imageUrl:this.props.src
        // })
    }

    handleImageErrored(){
        this.setState({
            imageUrl:defaultImg
        })
    }


    render() {

        return (
            <img
                className={this.props.type=='homelist'? styles["img-homelist"]:this.props.type=='record'?styles["img-record"]:this.props.type=='result'?styles["img-touxiang"]:styles.img}
                src={this.state.imageUrl}
                onLoad={this.handleImageLoaded.bind(this)}
                onError={this.handleImageErrored.bind(this)}
            />
        )
    }


}

Prompt.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Prompt);

